import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
//
import { LayoutModule } from '../layout/layout.module';
import { SharedModule } from '../shared/shared.module';
import { CoreComponent } from './core.component';
import { InactivityModalComponent } from './auth/inactivity-modal/inactivity-modal.component';

@NgModule({
  declarations: [CoreComponent, InactivityModalComponent],
  imports: [CommonModule, SharedModule, LayoutModule],
  exports: [CoreComponent, InactivityModalComponent],
  providers: [], // Removed AuthService - it's provided in root
})
export class CoreModule {}
